import { ExplainWithAIState } from "@/store/explain-with-ai/utils/types/common";
import { RootState } from "@/store/store";

export const explainWithAISliceSelector = (
  state: RootState,
): ExplainWithAIState => {
  return state.explainWithAi;
};
